/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setThemeApi = createAsyncThunk(
  "themeApi/setThemeApi",
  async (themeApi) => {
    return themeApi;
  }
);

const initialState = {
  theme_id: "",
  name: "",
  description: "",
  status: "active",
};

const themeApiSlice = createSlice({
  name: "themeApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setThemeApi.fulfilled, (state, action) => action.payload);
  },
});

export const selectThemeApi = ({ themeApi }) => themeApi;

export default themeApiSlice.reducer;
